module.exports = __webpack_public_path__ + "static/media/hair-salon-installation.48c50aff.png";